const translations = {
  en: {
    langName: 'English',
    brand: 'livefootball.space',
    onboarding: {
      skip: 'Skip',
      next: 'Next',
      start: 'See plans',
      signIn: 'Sign in',
      stepLabel: '{current} / {total}',
      slides: [
        {
          title: 'Live matches',
          text: 'Today’s games in one place — no link hunting.'
        },
        {
          title: 'Scores & news',
          text: 'Results and stories next to the streams.'
        },
        {
          title: 'Ready when you are',
          text: 'Open any match and hit Play — the stream is right there.'
        }
      ]
    },
    paywall: {
      brandMark: 'livefootball.space',
      title: 'Start watching live',
      subtitle: 'Start for $0.99. Unlock live streams and scores.',
      dayTitle: '1 Day Pass',
      dayPrice: '$0.99',
      dayPeriod: 'access',
      dayHint: 'Try it today',
      weekTitle: 'Weekly Pass',
      weekPrice: '$0.99',
      weekPeriod: 'access',
      weekHint: 'Best value',
      weekBadge: 'Popular',
      memberBadge: 'Membership',
      memberTitle: 'Live access',
      memberPrice: '$0.99',
      memberPeriod: 'to start',
      memberHint: 'Unlock live streams and scores',
      memberCta: 'Start for $0.99',
      cta: 'Pay with Stripe',
      processing: 'Redirecting to Stripe…',
      secure: 'Secure checkout powered by Stripe',
      features: [
        'All live & upcoming match streams',
        'Scores and football news included',
        'Cancel anytime'
      ],
      back: 'Back',
      legal: 'By continuing you agree to our service rules.',
      canceled: 'Checkout canceled. Choose a plan to try again.',
      verifying: 'Confirming payment…',
      verifyHint: 'Please wait while we unlock your access.',
      verifyMissing: 'Missing payment session.',
      verifyFailed: 'Payment verification failed.',
      backToPlans: 'Back to plans',
      ctaContinue: 'Continue',
      renewTitle: 'Renew your access',
      renewSubtitle: 'Your pass expired. Restart membership from $0.99.',
      signedInAs: 'Signed in as {email}',
      signOut: 'Sign out',
      auth: {
        registerTab: 'Create account',
        loginTab: 'Sign in',
        registerTitle: 'Create your account',
        loginTitle: 'Welcome back',
        registerHint: 'Create an account to unlock streams.',
        loginHint: 'Welcome back — members with an active pass go straight in.',
        email: 'Email',
        password: 'Password',
        passwordConfirm: 'Confirm password',
        passwordMismatch: 'Passwords do not match',
        registerCta: 'Create account',
        loginCta: 'Sign in',
        processing: 'Please wait…',
        failed: 'Something went wrong',
        errors: {
          EMAIL_EXISTS: 'This email is already registered. Sign in instead.',
          INVALID_CREDENTIALS: 'Wrong email or password. Try again.',
          INVALID_EMAIL: 'Enter a valid email address.',
          WEAK_PASSWORD: 'Password must be at least 6 characters.',
          PASSWORD_MISMATCH: 'Passwords do not match.',
          AUTH_RATE_LIMIT_EXCEEDED: 'Too many attempts. Please wait a few minutes and try again.',
          RATE_LIMIT_EXCEEDED: 'Too many requests. Please wait a moment and try again.',
          USER_NOT_FOUND: 'No account found with this email.',
          INVALID_PASSWORD: 'Current password is incorrect.',
          SAME_PASSWORD: 'New password must be different from the current one.',
          REGISTER_FAILED: 'Could not create your account. Please try again.',
          LOGIN_FAILED: 'Could not sign in. Please try again.',
          NETWORK_ERROR: 'Cannot reach the server. Please try again.'
        }
      }
    },
    gate: {
      checking: 'Checking access…'
    },
    nav: {
      home: 'Home',
      streams: 'Streams by League',
      news: 'Football News',
      scores: 'Match Scores',
      homeShort: 'Home',
      streamsShort: 'Streams',
      newsShort: 'News',
      scoresShort: 'Scores',
      signIn: 'Sign in',
      signUp: 'Sign up',
      signOut: 'Sign out',
      account: 'Account'
    },
    home: {
      welcome: 'livefootball.space',
      heroTitle: 'Watch live football',
      heroText: 'Streams, scores and headlines — one clean lobby.',
      promoKicker: 'Free streams',
      ctaLive: 'Watch live',
      footerKicker: 'livefootball.space',
      footerHeadline1: 'Stay on the',
      footerHeadline2: 'pitch',
      footerHeadline3: 'Never miss a kick.',
      footerOnAir: 'On air',
      footerMarquee: 'Live · Streams · Scores · News · Full time · Kick off ·',
      ctaNews: 'News',
      ctaStreams: 'By league',
      ctaScores: 'Scores',
      tileLiveTag: 'LIVE',
      tileLiveTitle: 'Live',
      tileLiveText: 'Jump into the match.',
      tileStreamsTitle: 'Leagues',
      tileNewsTag: 'NEWS',
      tileNewsTitle: 'News',
      tileNewsText: 'Transfers & matchday stories.',
      tileScoresTag: 'SCORES',
      tileScoresTitle: 'Scores',
      tileScoresText: 'Full catalog results.',
      featuredTitle: 'Popular',
      featuredWatch: 'Watch',
      featuredMore: 'All events',
      marketStream: 'Stream',
      railLive: 'Live',
      railNews: 'News',
      railScores: 'Scores',
      railStreams: 'Leagues',
      ticker: 'Premier League · La Liga · Serie A · Bundesliga · Ligue 1 · Champions League · MLS · Liga MX',
      filters: { all: 'All', live: 'Live', soon: 'Soon', finished: 'Finished' },
      filterDate: 'Date',
      filterLeague: 'League',
      allDates: 'All dates',
      allLeagues: 'All leagues',
      watch: 'Watch',
      empty: 'No matches for these filters',
      retry: 'Retry',
      connectionError: 'Could not reach the server. Check your connection and try again.',
      fetchError: 'Could not load matches'
    },
    streams: {
      title: 'Streams by League',
      subtitle: 'All upcoming matches by competition — filter a league and open the stream.',
      watch: 'Watch live',
      empty: 'No matches in the catalog yet',
      channels: 'matches',
      filterLeague: 'League',
      allLeagues: 'All leagues',
      filterDate: 'Date',
      allDates: 'All dates'
    },
    scores: {
      eyebrow: 'Results',
      title: 'Match Scores',
      subtitle: 'Finished matches from 2026 onwards — full-time scores by day and league.',
      empty: 'No finished matches for these filters',
      loading: 'Loading scores…',
      search: 'Search team or league',
      clear: 'Clear filters',
      today: 'Today',
      date: 'Date',
      allDates: 'All dates',
      league: 'League',
      allLeagues: 'All leagues',
      source: 'Source',
      matches: 'matches',
      winner: 'Winner',
      draw: 'Draw',
      ft: 'FT',
      vs: 'vs',
      filters: {
        all: 'All',
        live: 'Live',
        finished: 'Finished',
        soon: 'Upcoming'
      }
    },
    news: {
      title: 'Football News',
      subtitle: 'Transfers, tactics, match stories and league headlines — written for fans who stay until full time.',
      read: 'Read story',
      back: 'All news',
      related: 'Related stories',
      minRead: 'min read',
      all: 'All',
      eyebrow: 'Editorial',
      empty: 'No stories in this topic yet.',
      stories: 'stories',
      loadMore: 'Load more'
    },
    account: {
      eyebrow: 'Account',
      title: 'Your account',
      lead: 'Profile, membership billing, and security — in one place.',
      profileTitle: 'Profile',
      membershipTitle: 'Membership',
      securityTitle: 'Security',
      memberSince: 'Member since {date}',
      active: 'Active',
      expired: 'Inactive',
      planLabel: 'Plan: {plan}',
      planLabelShort: 'Plan',
      validUntil: 'Valid until',
      day: '1 Day',
      week: 'Weekly',
      membership: 'Membership',
      expires: 'Valid until {date}',
      renew: 'Choose a plan',
      changePlan: 'Change plan',
      manageBilling: 'Manage on Stripe',
      portalOpening: 'Opening Stripe…',
      portalNeedSub:
        'Subscribe once to open Stripe billing (cards, invoices, cancel).',
      portalError: 'Could not open Stripe. Try again in a moment.',
      billingHelp:
        'Cards, invoices, and cancellation are handled securely in Stripe Customer Portal.',
      securityHint: 'Use a strong password you don’t reuse elsewhere.',
      currentPassword: 'Current password',
      newPassword: 'New password',
      confirmPassword: 'Confirm new password',
      pwdSubmit: 'Update password',
      pwdSaving: 'Saving…',
      pwdOk: 'Password updated.',
      pwdMismatch: 'New passwords do not match.',
      pwdWeak: 'Password must be at least 6 characters.',
      pwdError: 'Could not change password.',
      watch: 'Watch live',
      signOut: 'Sign out',
      expiredHint: 'Choose a plan to unlock live streams and scores.',
      leadGuest: 'Your membership is saved on this device.',
      activeSince: 'Active since {date}',
      deviceHelp:
        'Access stays on this browser until your pass expires or you reset the session.',
      resetSession: 'Reset session'
    },
    lock: {
      guestTitle: 'Members only',
      guestText: 'Choose a plan to unlock live streams and scores.',
      renewTitle: 'Unlock to watch',
      renewText: 'Your pass is inactive. Choose a plan to continue.',
      choosePlan: 'Choose a plan'
    },
    paywallGate: {
      title: 'Watch live football',
      text: 'Start for $0.99. Unlock live streams and scores.',
      cta: 'Get access · $0.99',
      skip: 'Maybe later',
      dismiss: 'Dismiss'
    },
    player: {
      finishedTitle: 'Match finished',
      finishedText: 'This match has already ended.',
      notStartedTitle: 'Broadcast not started yet',
      notStartedText: 'The stream will appear closer to kickoff. Check back soon.',
      notStartedAt: 'The stream will appear closer to kickoff — {time}.',
      lockedTitle: 'Match has not started',
      lockedText: 'The broadcast will open automatically at kickoff',
      lockedTextAt: 'The broadcast will open automatically at kickoff — {time}.',
      streamError: 'Stream error',
      retry: 'Retry',
      pressPlay: 'Press Play to start the stream',
      noStream: 'No stream available',
      playerNotReady: 'Player is not ready yet — wait a second and tap Retry',
      videoLoadFailed: 'Could not load the video',
      connecting: 'Connecting…',
      noUrl: 'Stream has no URL',
      streamUrlFailed: 'Could not get stream URL',
      streamLoadFailed: 'Failed to load stream',
      networkRetry: 'Network — reconnecting…',
      mediaRecover: 'Media — recovering…',
      streamErrorDetail: 'Stream error: {detail}',
      hlsUnsupported: 'HLS is not supported in this browser',
      externalPlayer: 'External player',
      channel: 'Channel: {name}'
    }
  },
  pt: {
    langName: 'Português',
    brand: 'livefootball.space',
    onboarding: {
      skip: 'Saltar',
      next: 'Seguinte',
      start: 'Ver planos',
      signIn: 'Entrar',
      stepLabel: '{current} / {total}',
      slides: [
        {
          title: 'Jogos ao vivo',
          text: 'Os jogos de hoje num só sítio — sem caçar links.'
        },
        {
          title: 'Placares e notícias',
          text: 'Resultados e histórias ao lado dos streams.'
        },
        {
          title: 'Pronto quando quiseres',
          text: 'Abre qualquer jogo e carrega em Play — o stream está ali.'
        }
      ]
    },
    paywall: {
      brandMark: 'livefootball.space',
      title: 'Começa a ver ao vivo',
      subtitle: 'Começa por $0.99. Desbloqueia streams e placares.',
      dayTitle: 'Passe 1 Dia',
      dayPrice: '$0.99',
      dayPeriod: 'acesso',
      dayHint: 'Experimenta hoje',
      weekTitle: 'Passe Semanal',
      weekPrice: '$0.99',
      weekPeriod: 'acesso',
      weekHint: 'Melhor valor',
      weekBadge: 'Popular',
      memberBadge: 'Assinatura',
      memberTitle: 'Acesso ao vivo',
      memberPrice: '$0.99',
      memberPeriod: 'para começar',
      memberHint: 'Desbloqueia streams e placares',
      memberCta: 'Começar por $0.99',
      cta: 'Pagar com Stripe',
      processing: 'A redirecionar para o Stripe…',
      secure: 'Pagamento seguro via Stripe',
      features: [
        'Todos os streams ao vivo e próximos',
        'Placares e notícias incluídos',
        'Cancela quando quiseres'
      ],
      back: 'Voltar',
      legal: 'Ao continuar, aceitas as regras do serviço.',
      canceled: 'Checkout cancelado. Escolhe um plano e tenta de novo.',
      verifying: 'A confirmar o pagamento…',
      verifyHint: 'Aguarda enquanto desbloqueamos o acesso.',
      verifyMissing: 'Sessão de pagamento em falta.',
      verifyFailed: 'Falha na verificação do pagamento.',
      backToPlans: 'Voltar aos planos',
      ctaContinue: 'Continuar',
      renewTitle: 'Renova o teu acesso',
      renewSubtitle: 'O teu passe expirou. Reinicia a assinatura a partir de $0.99.',
      signedInAs: 'Sessão: {email}',
      signOut: 'Terminar sessão',
      auth: {
        registerTab: 'Criar conta',
        loginTab: 'Entrar',
        registerTitle: 'Cria a tua conta',
        loginTitle: 'Bem-vindo de volta',
        registerHint: 'Cria uma conta para desbloquear os streams.',
        loginHint: 'Bem-vindo de volta — com passe ativo entras direto na app.',
        email: 'Email',
        password: 'Palavra-passe',
        passwordConfirm: 'Confirmar palavra-passe',
        passwordMismatch: 'As palavras-passe não coincidem',
        registerCta: 'Criar conta',
        loginCta: 'Entrar',
        processing: 'Aguarde…',
        failed: 'Algo correu mal',
        errors: {
          EMAIL_EXISTS: 'Este email já está registado. Entra na conta em vez disso.',
          INVALID_CREDENTIALS: 'Email ou palavra-passe incorretos. Tenta de novo.',
          INVALID_EMAIL: 'Introduz um email válido.',
          WEAK_PASSWORD: 'A palavra-passe deve ter pelo menos 6 caracteres.',
          PASSWORD_MISMATCH: 'As palavras-passe não coincidem.',
          AUTH_RATE_LIMIT_EXCEEDED: 'Demasiadas tentativas. Espera alguns minutos e tenta de novo.',
          RATE_LIMIT_EXCEEDED: 'Demasiados pedidos. Espera um momento e tenta de novo.',
          USER_NOT_FOUND: 'Não existe conta com este email.',
          INVALID_PASSWORD: 'A palavra-passe atual está incorreta.',
          SAME_PASSWORD: 'A nova palavra-passe tem de ser diferente da atual.',
          REGISTER_FAILED: 'Não foi possível criar a conta. Tenta de novo.',
          LOGIN_FAILED: 'Não foi possível entrar. Tenta de novo.',
          NETWORK_ERROR: 'Não foi possível contactar o servidor. Tenta de novo.'
        }
      }
    },
    gate: {
      checking: 'A verificar acesso…'
    },
    nav: {
      home: 'Início',
      streams: 'Transmissões por Liga',
      news: 'Notícias de Futebol',
      scores: 'Placares',
      homeShort: 'Início',
      streamsShort: 'Ligas',
      newsShort: 'Notícias',
      scoresShort: 'Placares',
      signIn: 'Entrar',
      signUp: 'Registar',
      signOut: 'Sair',
      account: 'Conta'
    },
    home: {
      welcome: 'livefootball.space',
      heroTitle: 'Assiste futebol ao vivo',
      heroText: 'Streams, placares e manchetes — num só lobby.',
      promoKicker: 'Streams grátis',
      ctaLive: 'Ver ao vivo',
      footerKicker: 'livefootball.space',
      footerHeadline1: 'Fica no',
      footerHeadline2: 'campo',
      footerHeadline3: 'Não percas o pontapé.',
      footerOnAir: 'No ar',
      footerMarquee: 'Ao vivo · Streams · Placares · Notícias · Final · Kick-off ·',
      ctaNews: 'Notícias',
      ctaStreams: 'Por liga',
      ctaScores: 'Placares',
      tileLiveTag: 'AO VIVO',
      tileLiveTitle: 'Ao vivo',
      tileLiveText: 'Entra no jogo.',
      tileStreamsTitle: 'Ligas',
      tileNewsTag: 'NEWS',
      tileNewsTitle: 'Notícias',
      tileNewsText: 'Transferências e histórias.',
      tileScoresTag: 'SCORES',
      tileScoresTitle: 'Placares',
      tileScoresText: 'Todo o catálogo.',
      featuredTitle: 'Populares',
      featuredWatch: 'Ver',
      featuredMore: 'Todos',
      marketStream: 'Stream',
      railLive: 'Ao vivo',
      railNews: 'Notícias',
      railScores: 'Placares',
      railStreams: 'Ligas',
      ticker: 'Premier League · La Liga · Serie A · Bundesliga · Ligue 1 · Champions League · MLS · Liga MX',
      filters: { all: 'Tudo', live: 'Ao vivo', soon: 'Em breve', finished: 'Terminados' },
      filterDate: 'Data',
      filterLeague: 'Liga',
      allDates: 'Todas as datas',
      allLeagues: 'Todas as ligas',
      watch: 'Assistir',
      empty: 'Sem jogos nestes filtros',
      retry: 'Tentar de novo',
      connectionError: 'Não foi possível ligar ao servidor. Verifica a ligação e tenta de novo.',
      fetchError: 'Não foi possível carregar os jogos'
    },
    streams: {
      title: 'Transmissões por Liga',
      subtitle: 'Todos os jogos por competição — filtra a liga e abre a transmissão.',
      watch: 'Ver ao vivo',
      empty: 'Ainda sem jogos no catálogo',
      channels: 'jogos',
      filterLeague: 'Liga',
      allLeagues: 'Todas as ligas',
      filterDate: 'Data',
      allDates: 'Todas as datas'
    },
    scores: {
      eyebrow: 'Resultados',
      title: 'Placares',
      subtitle: 'Jogos terminados desde 2026 — resultados finais por dia e liga.',
      empty: 'Sem jogos terminados para estes filtros',
      loading: 'A carregar placares…',
      search: 'Pesquisar equipa ou liga',
      clear: 'Limpar filtros',
      today: 'Hoje',
      date: 'Data',
      allDates: 'Todas as datas',
      league: 'Liga',
      allLeagues: 'Todas as ligas',
      source: 'Fonte',
      matches: 'jogos',
      winner: 'Vencedor',
      draw: 'Empate',
      ft: 'FT',
      vs: 'vs',
      filters: {
        all: 'Tudo',
        live: 'Ao vivo',
        finished: 'Terminados',
        soon: 'Em breve'
      }
    },
    news: {
      title: 'Notícias de Futebol',
      subtitle: 'Transferências, tática, jogos e destaques das ligas — para quem fica até ao apito final.',
      read: 'Ler artigo',
      back: 'Todas as notícias',
      related: 'Histórias relacionadas',
      minRead: 'min de leitura',
      all: 'Tudo',
      eyebrow: 'Editorial',
      empty: 'Ainda não há histórias neste tema.',
      stories: 'histórias',
      loadMore: 'Carregar mais'
    },
    account: {
      eyebrow: 'Conta',
      title: 'A tua conta',
      lead: 'Perfil, faturação da membership e segurança — num só sítio.',
      profileTitle: 'Perfil',
      membershipTitle: 'Membership',
      securityTitle: 'Segurança',
      memberSince: 'Membro desde {date}',
      active: 'Ativo',
      expired: 'Inativo',
      planLabel: 'Plano: {plan}',
      planLabelShort: 'Plano',
      validUntil: 'Válido até',
      day: '1 Dia',
      week: 'Semanal',
      membership: 'Membership',
      expires: 'Válido até {date}',
      renew: 'Escolher plano',
      changePlan: 'Mudar plano',
      manageBilling: 'Gerir no Stripe',
      portalOpening: 'A abrir Stripe…',
      portalNeedSub:
        'Subscreve uma vez para abrir a faturação Stripe (cartões, faturas, cancelar).',
      portalError: 'Não foi possível abrir o Stripe. Tenta de novo.',
      billingHelp:
        'Cartões, faturas e cancelamento são tratados com segurança no Stripe Customer Portal.',
      securityHint: 'Usa uma palavra-passe forte que não reutilizes noutros sítios.',
      currentPassword: 'Palavra-passe atual',
      newPassword: 'Nova palavra-passe',
      confirmPassword: 'Confirmar nova palavra-passe',
      pwdSubmit: 'Atualizar palavra-passe',
      pwdSaving: 'A guardar…',
      pwdOk: 'Palavra-passe atualizada.',
      pwdMismatch: 'As novas palavras-passe não coincidem.',
      pwdWeak: 'A palavra-passe deve ter pelo menos 6 caracteres.',
      pwdError: 'Não foi possível alterar a palavra-passe.',
      watch: 'Ver ao vivo',
      signOut: 'Terminar sessão',
      expiredHint: 'Escolhe um plano para desbloquear streams e placares.',
      leadGuest: 'A tua subscrição fica guardada neste dispositivo.',
      activeSince: 'Ativo desde {date}',
      deviceHelp:
        'O acesso fica neste browser até o passe expirar ou repores a sessão.',
      resetSession: 'Repor sessão'
    },
    lock: {
      guestTitle: 'Só para membros',
      guestText: 'Escolhe um plano para desbloquear streams e placares.',
      renewTitle: 'Desbloqueia para ver',
      renewText: 'O teu passe está inativo. Escolhe um plano para continuares.',
      choosePlan: 'Escolher plano'
    },
    paywallGate: {
      title: 'Ver futebol ao vivo',
      text: 'Começa por $0,99. Desbloqueia streams e placares.',
      cta: 'Obter acesso · $0,99',
      skip: 'Talvez mais tarde',
      dismiss: 'Fechar'
    },
    player: {
      finishedTitle: 'Jogo terminado',
      finishedText: 'Este jogo já acabou.',
      notStartedTitle: 'A transmissão ainda não começou',
      notStartedText: 'O stream aparece perto do início do jogo. Volta em breve.',
      notStartedAt: 'O stream aparece perto do início do jogo — {time}.',
      lockedTitle: 'O jogo ainda não começou',
      lockedText: 'A transmissão abre automaticamente no início do jogo',
      lockedTextAt: 'A transmissão abre automaticamente no início do jogo — {time}.',
      streamError: 'Erro no stream',
      retry: 'Tentar de novo',
      pressPlay: 'Carrega em Play para iniciar o stream',
      noStream: 'Sem stream disponível',
      playerNotReady: 'O leitor ainda não está pronto — espera um segundo e toca em Retry',
      videoLoadFailed: 'Não foi possível carregar o vídeo',
      connecting: 'A ligar…',
      noUrl: 'O stream não tem URL',
      streamUrlFailed: 'Não foi possível obter o URL do stream',
      streamLoadFailed: 'Falha ao carregar o stream',
      networkRetry: 'Rede — a reconectar…',
      mediaRecover: 'Media — a recuperar…',
      streamErrorDetail: 'Erro no stream: {detail}',
      hlsUnsupported: 'HLS não é suportado neste browser',
      externalPlayer: 'Leitor externo',
      channel: 'Canal: {name}'
    }
  }
};

export default translations;
